import * as React from 'react';
import { createPortal } from 'react-dom';

export const ClientPortal: React.FC<React.PropsWithChildren> = props => {
  return createPortal(props.children, document.body);
};
